



























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { getRank, getTotalData } from '../api';
import { share } from '../api';

Vue.use(List);
@Component
export default class Rank extends Vue {
  totalCount = {};
  tabs = ['区域排名', '学校排名'];
  active = 0;
  loading = false;
  finished = false;
  page = 1;
  getListData: any[] = [];
  listType = 1;
  signlog = false;
  created() {
    const signlog = this.$route.query.signlog;
    if (signlog && signlog === '888') {
      this.signlog = true;
    }
    this.fetchTotalCount();
  }
  handleClickTab(index: number) {
    this.active = index;
    this.listType = index + 1;
  }
  async fetchTotalCount() {
    const res = await getTotalData();
    this.totalCount = res.data;
  }
  // 初使加载
  async onLoad() {
    this.loading = true;

    const res = await getRank(this.listType, this.page);
    this.fetchListData(res);
  }
  fetchListData(res: any) {
    if (res.status === 1 || res.code === 500 || res.msg === '暂无数据') {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
      this.finished = false;
    }
    this.loading = false;
  }

  goSearch(text: string) {
    if (this.active === 0) {
      this.$router.push('home?search=' + text);
    }
  }
  @Watch('active')
  onListTypeChanged() {
    this.loading = false;
    this.finished = false;
    this.page = 1;
    this.getListData = [];
    this.onLoad();
  }
}
